import Modal from "components/Modal";
import { useState } from "react";
import loadingGif from "images/loader2.webp";
import { notifySuccess, notifyError } from "utils/customToasts";
import { useAuth } from 'context/AuthContext';
import CreatableUserSelect from 'components/Dropdown/CreatableUserSelect';
import { shareFormSurveyLinkThunk } from "slices/chat/thunk";
import { useDispatch } from "react-redux";

const RunSurveyModal = ({ isEdit = false, open, onClose, data, onSave, formSurveyLinks }) => {

    const [loading, setLoading] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isCustomShare, setIsCustomShare] = useState(false);
    const dispatch = useDispatch();

    // Share form
    const handleSubmitForm = async () => {
        setLoading(true);
        try {

            if (!formSurveyLinks?.sharable_link) {
                setLoading(false);
                return notifyError("Sharable link is not available");
            }

            if (!selectedUsers?.length) {
                setLoading(false);
                return notifyError("Please select at least one recipient");
            }

            const payload = {
                recipients: selectedUsers.map(user => {
                    if (user?.email) {
                        return user.email
                    }
                    return user.value
                }),
                sharable_link: formSurveyLinks.sharable_link
            }

            await dispatch(shareFormSurveyLinkThunk(payload))
            setLoading(false);
            notifySuccess("Form Shared");
        } catch (error) {
            setLoading(false);
            return notifyError(error?.message || "unable to share, something went wrong");
        }
    };

    // Reset States on Close
    const resetModalStates = () => {
        onClose();
        setLoading(false);
        setIsCustomShare(false);
    }

    const handleUserSelect = (newUsers) => {
        setSelectedUsers(newUsers);
    }

    const handleFormPreview = () => {
        if (!formSurveyLinks?.preview_link) {
            return notifyError("Preview Link is not available");
        }

        window.open(formSurveyLinks.preview_link, "_blank", "noreferrer");
    }

    const handleCustomShare = () => {
        setIsCustomShare(prev => !prev)
    }

    return (
        <Modal
            position="top-right"
            className="relative w-[40rem] px-8 py-10 bg-primary-3 text-white rounded-lg text-left"
            open={open}
        >
            <h1 className={`text-center text-2xl`}>Run Form Survey</h1>

            <div className="flex justify-center mt-10 gap-4">

                <button
                    disabled={loading}
                    className="py-2 flex-grow text-gray-300 px-4 border border-gray-200 rounded"
                    onClick={handleCustomShare}
                >
                    Share to Users
                </button>

                <button
                    onClick={handleFormPreview}
                    disabled={loading}
                    className="py-2 flex-grow  bg-primary-1 text-white px-4 rounded flex gap-2 justify-center items-center disabled:bg-gray-600 disabled:text-gray-300"
                >
                    <span>
                        Form Preview
                    </span>
                </button>
            </div>

            {
                isCustomShare && (
                    <div className={`mt-10`}>
                        {/* Select users List */}
                        <div className="flex flex-col gap-2">
                            <div className="text-sm text-left">
                                <span>Enter recipients emails</span>
                                <span className={`text-red-500 ml-[1px] text-base`}> *</span>
                            </div>

                            <CreatableUserSelect
                                selectedOption={selectedUsers}
                                onChange={handleUserSelect}
                            />
                        </div>
                    </div>

                )
            }

            {/* Action Buttons */}
            <div className={`flex ${isCustomShare ? "justify-between" : "justify-center"} mt-10 gap-4`}>

                <button
                    disabled={loading}
                    className="py-2 text-gray-300 px-4 border border-gray-200 rounded"
                    onClick={resetModalStates}
                >
                    Close
                </button>

                {
                    isCustomShare && (
                        <button
                            disabled={loading}
                            className="py-2 bg-primary-1 text-gray-400 px-4 rounded text-white flex gap-2 items-center disabled:bg-gray-600 disabled:text-gray-300"
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmitForm();
                            }}
                        >
                            {
                                loading && (
                                    <img src={loadingGif} alt="loading" className={`h-4 w-4`} />
                                )
                            }
                            <span>
                                Share
                            </span>
                        </button>
                    )
                }
            </div>
        </Modal>
    );
}

export default RunSurveyModal